document.addEventListener("DOMContentLoaded", function () {
  const addArrowsToLists = () => {
     const lists = document.querySelectorAll(".nona-list");
    lists.forEach((list) => {
      if (list.scrollWidth > list.clientWidth) {
         list.classList.add("overflowwing");
      } else {
        list.classList.remove("overflowwing");
      }
    });
  };

  addArrowsToLists();
  window.addEventListener("resize", addArrowsToLists);

  const scrollLeftArrows = document.querySelectorAll(".scroll-left");
  const scrollRightArrows = document.querySelectorAll(".scroll-right");

  scrollLeftArrows.forEach((arrow) => {
    arrow.addEventListener("click", () => {
      const list = arrow.parentElement.previousElementSibling;

      if (list.scrollLeft === 0) {
        list.scrollTo({
          left: list.scrollWidth,
          behavior: "smooth",
        });
      } else {
        list.scrollBy({
          left: -list.clientWidth,
          behavior: "smooth",
        });
      }
    });
  });

  scrollRightArrows.forEach((arrow) => {
    arrow.addEventListener("click", () => {
      const list = arrow.parentElement.previousElementSibling;

      // if at back go to front
      if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
        list.scrollTo({
          left: 0,
          behavior: "smooth",
        });
      } else {
        list.scrollBy({
          left: list.clientWidth,
          behavior: "smooth",
        });
      }
    });
  });
});
